import React from "react";
import "../CustomTheme/customTheme.css";
import "./CustomBadge.css";

const STATUS_TONE = {
  active: "success",
  approved: "success",
  success: "success",
  completed: "success",
  paid: "success",
  enabled: "success",
  published: "success",
  inactive: "neutral",
  disabled: "neutral",
  draft: "neutral",
  closed: "neutral",
  pending: "warning",
  review: "warning",
  "in review": "warning",
  scheduled: "warning",
  running: "info",
  processing: "info",
  "in progress": "info",
  new: "info",
  // payment gateway (Razorpay) statuses
  captured: "success",
  authorized: "info",
  created: "warning",
  attempted: "warning",
  refunded: "warning",
  rejected: "danger",
  failed: "danger",
  error: "danger",
  cancelled: "danger",
  canceled: "danger",
  expired: "danger",
  blocked: "danger",
};

/** Maps a status word (any case) to a badge tone; unknown words → "neutral". */
export const getStatusTone = (status) => {
  const key = String(status ?? "").trim().toLowerCase();
  // own keys only, so "constructor" / "toString" don't pick up Object.prototype
  return Object.prototype.hasOwnProperty.call(STATUS_TONE, key) ? STATUS_TONE[key] : "neutral";
};

/**
 * CustomBadge — small coloured label for statuses, sources, counts.
 *
 *   <CustomBadge status="failed" />                 → red "failed"
 *   <CustomBadge tone="info">WHATSAPP</CustomBadge>
 *   <CustomBadge status={row.isEnabled ? "active" : "inactive"} dot />
 *
 * Props:
 *  - children | label   text (defaults to `status`)
 *  - status    picks the tone automatically (see getStatusTone)
 *  - tone      "primary" | "success" | "danger" | "warning" | "info" | "neutral"
 *  - variant   "soft" (default) | "solid" | "outline"
 *  - size      "sm" | "md" (default)
 *  - dot       shows a coloured dot before the text
 *  - icon      optional icon element before the text
 *  - title, className, style
 */
const CustomBadge = ({
  children,
  label,
  status,
  tone,
  variant = "soft",
  size = "md",
  dot = false,
  icon,
  title,
  className,
  style,
}) => {
  const resolvedTone = tone || (status !== undefined ? getStatusTone(status) : "neutral");
  const text = children ?? label ?? status ?? "—";

  return (
    <span
      className={`cbd-badge cbd-${resolvedTone} cbd-${variant} cbd-${size}${
        className ? ` ${className}` : ""
      }`}
      title={title ?? (typeof text === "string" ? text : undefined)}
      style={style}
    >
      {dot && <span className="cbd-dot" aria-hidden="true" />}
      {icon && <span className="cbd-icon">{icon}</span>}
      <span className="cbd-text">{text}</span>
    </span>
  );
};

export default CustomBadge;
